@if (editarCuenta !== true) {
<div class="modal-header bg-light">
  <h4 class="modal-title">Nueva configuraci&oacute;n de Cuenta</h4>
  <button type="button" class="btn-close" aria-label="Close" (click)="this.activeModal.dismiss()">
  </button>
</div>
}
<form [formGroup]="clientesIataForm">
  @if (clienteNuevo === true) {
  <div class="modal-body">
    <div class="row">
      <div class="mb-3 row col-md-12">
        <label class="col-9 col-form-label mb-3">Raz&oacute;n social del cliente solicitante:</label>
        <div class="col-12">
          <input type="text" formControlName="razonSocialFormControl" placeholder="Raz&oacute;n social"
            [inputFormatter]="formatter" [resultFormatter]="formatter" [ngbTypeahead]="search" class="form-control">
          <div class="alert alert-danger"
            *ngIf="(this.razonSocial.invalid && this.razonSocial.errors.required && (this.razonSocial.dirty || this.razonSocial.touched))">
            Requerido.
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="modal-footer bg-light">
    <button class="btn btn-primary me-2" id="aceptar" [disabled]="!puedeGuardar()" (click)="onSubmit()">
      @if(guardandoNuevaConfiguracion) {
      <div class="d-flex align-items-center">
        <div class="spinner-border text-light spinner-border-sm" role="status"></div>
        <span>Guardando...</span>
      </div>
      } @else {
      <span>Agregar</span>
      }
    </button>
    <span class="border">
      <button type="button" class="btn btn-secondary" (click)="activeModal.dismiss('Close clicked')">Cancelar</button>
    </span>
  </div>
  } @else {
  <div class="modal-body">
    @if (editarCuenta === false) {
    <div class="row">
      <div class="mb-3 row col-6">
        <label for="cuentaSolicitanteFormControl" class="col-5 col-form-label">Cuenta solicitante:</label>
        <div class="col-7">
          <select [disabled]="cargandoCuentas" id="cuentaSolicitanteFormControl" class="form-select"
            ngbTooltip="Seleccione la cuenta solicitante." formControlName="cuentaSolicitanteFormControl">
            <option *ngFor="let cuenta of listaCuentasSolicitantes" [ngValue]="cuenta">
              {{ cuenta.descripcion }} ({{cuenta.ctA_SGC}})
            </option>
          </select>
          <loading-text-spinner *ngIf="cargandoCuentas" message="Obteniendo cuentas..." color="primary">
          </loading-text-spinner>
          <div class="alert alert-danger"
            *ngIf="(this.cuentaSolicitanteFormControl.invalid && this.cuentaSolicitanteFormControl.errors.required && (this.cuentaSolicitanteFormControl.dirty || this.cuentaSolicitanteFormControl.touched))">
            Debe seleccionar una cuenta solicitante.
          </div>
        </div>
      </div>
    </div>
    }
    <div class="row">
      <div class="mb-3 row col-6">
        <label for="clienteImputarFormControl{{index}}" class="col-5 col-form-label">Cliente a imputar:</label>
        <div class="col-7">
          <input class="form-control" id="clienteImputarFormControl{{index}}" placeholder="Raz&oacute;n social"
            [inputFormatter]="formatter" 
            [resultFormatter]="formatter"
            [ngbTypeahead]="searchImputar"
            (selectItem)="selectClienteImputar($event)"
            class="form-control" formControlName="clienteImputarFormControl"
            maxlength="50">
          <div class="alert alert-danger"
            *ngIf="(this.clienteImputarFormControl.invalid && this.clienteImputarFormControl.errors.required && (this.clienteImputarFormControl.dirty || this.clienteImputarFormControl.touched))">
            Requerido.
          </div>
        </div>
      </div>
      <div class="mb-3 row col-6">
        <label for="cuentaImputarFormControl{{index}}" class="col-5 col-form-label">*Cuenta a imputar:</label>
        <div class="col-7">
          <select [compareWith]="compareCuentas" id="cuentaImputarFormControl{{index}}" class="form-select"
            ngbTooltip="Seleccione la cuenta a imputar." formControlName="cuentaImputarFormControl">
            <option *ngFor="let cuenta of listaCuentasAImputar" [ngValue]="cuenta">
              {{ cuenta.descripcion }}
            </option>
          </select>
          <loading-text-spinner *ngIf="obteniendoCuentasImputar" message="Obteniendo cuentas..." color="primary">
          </loading-text-spinner>
          <div class="alert alert-danger"
            *ngIf="(this.cuentaImputarFormControl.invalid && this.cuentaImputarFormControl.errors.required && (this.cuentaImputarFormControl.dirty || this.cuentaImputarFormControl.touched))">
            Debe seleccionar una cuenta solicitante.
          </div>
        </div>
      </div>
    </div>
    <div class="mb-3 row col-12">
      <div class="row">
        <label for="aeroplantasFormControl{{index}}" class="col-3 col-form-label">Agregar aeroplantas:</label>
        <div class="col-6">
          <div class="col-md-12">
            <div class="input-group mb-2">
              <select id="aeroplantasFormControl" type="text" class="form-select"
                formControlName="aeroplantasFormControl" title="Seleccione una aeroplanta">
                <option [value]="null" [disabled]="cargandoAeroplantas" defaultselected>Seleccione una opci&oacute;n...
                </option>
                <option *ngFor="let aero of aeroplantasDisponibles" [ngValue]="aero">
                  {{ aero.nombre }}
                </option>
              </select>
            </div>
            <loading-text-spinner *ngIf="cargandoAeroplantas" message="Obteniendo aeroplantas..." color="primary">
            </loading-text-spinner>
          </div>
        </div>
        <div class="col-3">
          <button (click)="agregarAeroplanta()" type="button" class="btn btn-primary me-2">Agregar</button>
          <button (click)="agregarTodasAeroplanta()" type="button" class="btn btn-primary">Todas</button>
        </div>
      </div>
      <div *ngIf="aeroplantasLista" class="row col-10 mt-4 ms-3" style="padding: 1em; border: 1px solid #ccc;">
        <div class="mb-3 row col-12">
          <div class="col-4">Aeroplantas asignadas</div>
          <div class="col-8 overflow-auto" style="max-height: 200px;">
            <ng-container *ngIf="aeroplantas.length > 0; else noAeroplantas">
              <div *ngFor="let aeroplanta of aeroplantas"
                class="d-flex justify-content-between align-items-center py-2">
                <span>{{ getNombreAeroplanta(aeroplanta) }}</span>
                <button type="button" class="btn btn-danger btn-sm" ngbTooltip="Quitar aeroplanta"
                  (click)="onEliminarAeroplanta(aeroplanta)">
                  <i class="fa fa-trash"></i>
                </button>
              </div>
            </ng-container>
            <ng-template #noAeroplantas>
              <div class="alert alert-warning">
                No se han cargado aeroplantas.
              </div>
            </ng-template>
          </div>
        </div>
      </div>
    </div>
  </div>
  <small class="text-danger">*Campos obligatorios.</small>
  <div class="modal-footer justify-content-center bg-light">
    <button class="btn btn-primary me-2" [disabled]="!puedeGuardar()" (click)="onSubmit()">
      @if (!guardando){
      <span>Guardar</span>
      }
      @else{
      <div class="d-flex align-items-center">
        <div class="spinner-border text-light spinner-border-sm" role="status"></div>
        <span>Guardando...</span>
      </div>
      }
    </button>
    @if (editarCuenta === false) {
    <span class="border">
      <button type="button" class="btn btn-secondary" (click)="activeModal.dismiss('Close clicked')">Cancelar</button>
    </span>
    }
  </div>
  }
</form>